import EditorBottomSheet from './EditorBottomSheet.component';

export default EditorBottomSheet;
